export default __webpack_public_path__ + "static/media/Group1625.634e0b98.png";